module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "children"
  }, [_c('div', {
    staticClass: "children__text"
  }, [_vm._v("Пользователи, учacтвyющиe в мероприятии")]), _c('ol', {
    staticClass: "children__list"
  }, _vm._l((_vm.items), function(ref, index) {
    var fullName = ref.fullName;
    var birthday = ref.birthday;

    return _c('li', {
      key: index,
      staticClass: "children__item"
    }, [_c('div', {
      staticClass: "children__info"
    }, [_c('span', [_vm._v(_vm._s(fullName))]), _vm._v(", " + _vm._s(birthday))]), _c('div', {
      staticClass: "children__remove",
      on: {
        "click": function($event) {
          return _vm.$emit('removeChild', index)
        }
      }
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0aed576","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderChildren.vue
// module id = 4ae41d7030e36f5fa6ba
// module chunks = 0